import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawDeleteContentIcon from "./RawDeleteContentIcon.svg.jsx";

const DeleteContentIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawDeleteContentIcon} {...props} />;
});

export default DeleteContentIcon;
